import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/restaur.jpg";
import "../style/styles.css";
import "../style/Restaurant.css";

const Restaurant = () => {
  const alText =
    "Restaurant interior representing RestaurSof POS billing, KOT and stock management workflow";

  const quickStats = [
    { value: "KOT", label: "Kitchen Orders" },
    { value: "BOT", label: "Billing Orders" },
    { value: "GST", label: "Enabled Reports" },
    { value: "POS", label: "Desktop / Web" },
  ];

  const keyModules = [
    {
      title: "POS Billing & KOT/BOT",
      text:
        "Manage restaurant POS billing, KOT/BOT, KOT billing, touch screen billing, desktop billing, web application billing, Android app orders and room service operations.",
    },
    {
      title: "Restaurant, Bar & Pubs",
      text:
        "Suitable for restaurants, bars, pubs, cafes, food courts and dine-in businesses with table-wise orders, waiter-wise reports, bar stock and GST billing.",
    },
    {
      title: "Stock Inventory",
      text:
        "Control kitchen raw material stock, store stock, wine and beverage stock, department-wise stock, store issue, consumption analysis and purchase analysis.",
    },
    {
      title: "MIS Reports",
      text:
        "Generate KOT register, void KOT register, NC KOT register, date-wise product sales, GST sales, payment type wise collection, night audit and restaurant sales reports.",
    },
    {
      title: "Full Accounting",
      text:
        "Generate cash bank book, journal book, debit note, credit note, purchase, sales, ledger, trial balance, profit and loss and GST accounting reports.",
    },
    {
      title: "QR Code Menu & Android Ordering",
      text:
        "QR code menu and Android ordering allow customers or staff to place food orders digitally for smooth restaurant, bar and pub operations.",
    },
  ];

  const entryFeatures = [
    "KOT / BOT",
    "KOT / BOT Billing",
    "Restaurant POS Billing",
    "Touch Screen POS Billing",
    "Desktop Application Billing",
    "Web Application Billing",
    "KOT and KOT Billing from Android App",
    "QR Code Menu Ordering",
    "Room Service",
    "Raw Material Purchase",
    "Kitchen Raw Material Stock",
    "Purchase Return",
    "Store Issue",
    "Department Indent",
    "Purchase Order",
    "Food Menu Recipe Analysis",
    "Food Costing Configuration",
    "Order Generating on Order Level",
  ];

  const misReportsLeft = [
    "KOT Register",
    "Void KOT Register",
    "NC KOT Register",
    "Product Sales Register Date Wise",
    "Sales Register Including GST",
    "GST Rate Wise Sales Register",
    "Payment Type Wise Sales and Collection Register",
    "Restaurant Night Audit Report",
    "Department Wise Restaurant Sales Report",
    "Shift Wise Restaurant Sales Report",
    "Complimentary Restaurant Sales Report",
    "Waiter Wise Restaurant Sales Report",
    "Table Wise Restaurant Sales Report",
    "Bar Sales Report",
    "Pubs Sales Report",
    "Graphical Report for Visitors Analysis",
  ];

  const stockReports = [
    "Store Raw Material Purchase",
    "Kitchen Raw Material Stock",
    "Issue Raw Material to Various Department",
    "Analysis of Finished Food",
    "Raw Material Stock Kitchen Wise",
    "Raw Material Stock Department Wise",
    "Wine and Beverage Stock Store Wise",
    "Wine and Beverage Stock Department Wise",
    "Bar Stock Register",
    "Pubs Stock Register",
    "Store Stock Overall",
    "Store Consumption Analysis",
    "Store Purchase Analysis",
    "Indent Generating",
    "Purchase Order Register",
    "Pending Indent",
    "Food Costing",
    "Recipe Costing",
  ];

  const misReportsRight = [
    "Supplier Wise Product Purchase Register",
    "Supplier Wise Monthly Product Purchase Report",
    "Department Wise Store Consumption Reports",
    "Kitchen Wise Raw Material Consumption",
    "Pending Purchase Order Register",
  ];

  const accountingReports = [
    "Cash Bank Book",
    "Journal Book",
    "Debit Note Register",
    "Credit Note Register",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Expense Trial",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Statement of Expenditure",
    "Cost Centre Reports",
    "GST Type Wise Sales Register",
    "GSTR-I, GSTR-II and GSTR-3B Reports",
  ];

  const seoPainPoints = [
    {
      title: "POS billing for restaurant, bar and pubs",
      text:
        "RestaurSof helps restaurants, bars and pubs manage POS billing, KOT/BOT, touch screen billing, desktop billing, web application billing, Android orders and GST invoices.",
    },
    {
      title: "Kitchen raw material stock control",
      text:
        "RestaurSof tracks kitchen raw material stock, store stock, wine and beverage stock, department issue, store consumption, purchase and pending indent reports.",
    },
    {
      title: "Recipe and food costing reports",
      text:
        "RestaurSof supports food menu recipe analysis, recipe costing, food costing configuration, finished food analysis and raw material consumption control.",
    },
    {
      title: "Full accounts with GST enabled reports",
      text:
        "RestaurSof includes cash bank book, purchase register, sales register, ledger, trial balance, profit and loss, GST sales register and GSTR reports.",
    },
  ];

  const solutionAreas = [
    {
      title: "Restaurant POS billing for desktop and web",
      text:
        "RestaurSof supports restaurant POS billing for desktop and web application users. It helps restaurants manage counter billing, table orders, KOT/BOT billing, payment collection, GST invoices and daily sales control from one organized workflow.",
      points: [
        "Desktop POS billing",
        "Web application billing",
        "Touch screen billing",
        "KOT and BOT billing",
        "Table-wise sales",
        "Payment-wise collection",
      ],
    },
    {
      title: "Restaurant, bar and pubs operations",
      text:
        "The system is suitable for restaurants, bars, pubs, cafes, food courts and dine-in businesses that need practical order taking, bar billing, waiter-wise reporting, shift-wise sales, night audit and GST-ready sales registers.",
      points: [
        "Restaurant billing",
        "Bar billing",
        "Pubs billing",
        "Waiter-wise reports",
        "Shift-wise sales",
        "Night audit",
      ],
    },
    {
      title: "Kitchen raw material stock and inventory",
      text:
        "RestaurSof manages kitchen raw material stock, store stock, wine and beverage stock, department-wise stock, store issue, purchase order, pending indent and consumption reports to improve stock control.",
      points: [
        "Kitchen raw material stock",
        "Store stock",
        "Wine and beverage stock",
        "Department-wise stock",
        "Store issue",
        "Purchase order",
      ],
    },
    {
      title: "Recipe, food costing and consumption control",
      text:
        "Restaurants can control food costing with recipe analysis, finished food analysis, raw material consumption and menu costing. This helps owners understand food cost, stock usage and product performance.",
      points: [
        "Recipe analysis",
        "Food costing",
        "Finished food analysis",
        "Menu costing",
        "Raw material consumption",
        "Kitchen cost control",
      ],
    },
    {
      title: "QR menu and Android ordering",
      text:
        "RestaurSof supports QR code menu and Android ordering for modern restaurant operations. Orders can be generated from tables, rooms or mobile devices and connected with KOT billing.",
      points: [
        "QR code menu",
        "Android ordering",
        "Mobile order taking",
        "Room service orders",
        "Digital menu",
        "Contactless ordering",
      ],
    },
    {
      title: "Full accounting with GST reports",
      text:
        "RestaurSof includes full accounting with cash bank book, purchase register, sales register, ledger, trial balance, profit and loss, GST type-wise sales register and GSTR reports.",
      points: [
        "Cash bank book",
        "Purchase register",
        "Sales register",
        "Ledger",
        "Trial balance",
        "GST reports",
      ],
    },
  ];

  const faqList = [
    {
      question: "What is RestaurSof restaurant software?",
      answer:
        "RestaurSof is restaurant, bar and pubs management software for POS billing, KOT/BOT, inventory, kitchen raw material stock, GST reports, MIS reports and full accounting.",
    },
    {
      question: "Does RestaurSof support desktop and web application?",
      answer:
        "Yes. RestaurSof supports desktop and web application based restaurant operations with POS billing, stock, reports and accounting modules.",
    },
    {
      question: "Can RestaurSof manage kitchen raw material stock?",
      answer:
        "Yes. RestaurSof manages kitchen raw material stock, store stock, department issue, raw material purchase, store consumption, wine and beverage stock and food costing.",
    },
    {
      question: "Does RestaurSof support KOT, BOT and Android ordering?",
      answer:
        "Yes. RestaurSof supports KOT, BOT, KOT billing, Android app ordering, waiter ordering, QR code menu and room service ordering.",
    },
    {
      question: "Does RestaurSof include full accounting and GST reports?",
      answer:
        "Yes. RestaurSof includes purchase register, sales register, ledger, trial balance, profit and loss, cash bank book, GST sales register and GSTR reports.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/restaurant";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImagePath = String(web5 || "");
  const heroImageUrl = heroImagePath.startsWith("http")
    ? heroImagePath
    : `${siteUrl}${heroImagePath.startsWith("/") ? heroImagePath : `/${heroImagePath}`}`;

  const seoTitle =
    "Restaurant POS Software | RestaurSof for KOT, BOT, Inventory, Bar, Pubs & GST Accounting";

  const seoDescription =
    "RestaurSof is restaurant, bar and pubs software for desktop and web application POS billing, KOT, BOT, kitchen raw material stock, inventory, full accounting and GST enabled reports.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "RestaurSof",
    alternateName: "Restaurant POS and Inventory Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows, Web, Android",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "RestaurSof",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "Offer",
      price: "15000",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      description: "1 licence / multi-user RestaurSof restaurant software package.",
    },
    featureList: [
      "Restaurant POS billing",
      "KOT and BOT billing",
      "Desktop and web application support",
      "Android ordering app",
      "QR code menu",
      "Restaurant, bar and pubs billing",
      "Kitchen raw material stock",
      "Restaurant stock inventory",
      "Wine and beverage stock",
      "Recipe and food costing",
      "GST enabled reports",
      "Full restaurant accounting",
      "MIS reports and night audit",
    ],
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "RestaurSof Restaurant POS Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="restaurant-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="restaurant-hero">
        <img
          className="restaurant-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="restaurant-hero-overlay"></div>

        <Container className="restaurant-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="restaurant-hero-content">
                <div className="restaurant-kicker">Restaurant POS / KOT Software</div>
                <h1>RestaurSof</h1>
                <h2>
                  Restaurant, Bar & Pubs POS Software with Stock, GST and Accounts
                </h2>
                <p>
                  RestaurSof is a GST enabled restaurant software for
                  restaurants, bars and pubs. It supports desktop and web
                  application operations with POS billing, KOT/BOT, Android
                  ordering, QR code menu, kitchen raw material stock, inventory,
                  MIS reports and full financial accounting.
                </p>

                <div className="restaurant-hero-actions">
                  <a href="#restaurant-modules" className="restaurant-btn restaurant-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="restaurant-btn restaurant-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="restaurant-price-card">
                <span>1 Licence / Multi-User</span>
                <strong>₹15,000/- + GST</strong>
                <p>
                  Touch screen enabled restaurant, bar and pubs software with
                  desktop/web support, Android app, QR menu, KOT/BOT billing,
                  kitchen stock, MIS, GST and full accounts.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="restaurant-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="restaurant-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="restaurant-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="restaurant-section-label">Overview</div>
              <h2 className="restaurant-section-title">
                Restaurant POS billing, kitchen stock, inventory and accounting
              </h2>
              <p className="restaurant-text">
                RestaurSof helps restaurants, bars and pubs manage order taking,
                kitchen order tickets, BOT billing, POS billing, kitchen raw
                material stock, wine and beverage stock, purchase, consumption,
                GST enabled reports and financial accounting from one practical
                software platform.
              </p>
              <p className="restaurant-text">
                The software is suitable for desktop and web application based
                operations and supports QR code menu and Android ordering so
                customers or staff can place food orders digitally from table,
                room or restaurant counter.
              </p>
            </Col>

            <Col lg={6}>
              <div className="restaurant-overview-card">
                <h3>RestaurSof covers</h3>
                <div className="restaurant-overview-grid">
                  <div><span>✓</span><p>Restaurant POS</p></div>
                  <div><span>✓</span><p>KOT / BOT</p></div>
                  <div><span>✓</span><p>Bar & Pubs</p></div>
                  <div><span>✓</span><p>Kitchen Stock</p></div>
                  <div><span>✓</span><p>Inventory</p></div>
                  <div><span>✓</span><p>Accounting & GST</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="restaurant-seo-section">
        <Container>
          <div className="restaurant-heading-center">
            <div className="restaurant-section-label">Why Restaurants Choose RestaurSof</div>
            <h2 className="restaurant-section-title">
              Restaurant software built for POS billing, KOT, inventory, kitchen stock and GST accounting
            </h2>
            <p>
              RestaurSof is designed for restaurants, bars, pubs and food
              businesses that need better control over POS billing, KOT/BOT,
              kitchen raw material stock, inventory, purchase, consumption, GST,
              MIS reports and full accounting.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="restaurant-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="restaurant-modules-section" id="restaurant-modules">
        <Container>
          <div className="restaurant-heading-center">
            <div className="restaurant-section-label">Key Modules</div>
            <h2 className="restaurant-section-title">
              Complete restaurant workflow from KOT to accounting
            </h2>
            <p>
              RestaurSof connects KOT/BOT, POS billing, Android ordering, room
              service, kitchen raw material purchase, stock inventory, MIS and
              accounting reports in one organized restaurant management system.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="restaurant-module-card">
                  <div className="restaurant-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="restaurant-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="restaurant-list-card">
                <div className="restaurant-section-label">Entry Module</div>
                <h2>POS billing, KOT/BOT and order entries</h2>
                <ul>
                  {entryFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="restaurant-list-card restaurant-list-card-dark">
                <div className="restaurant-section-label">MIS Reports</div>
                <h2>Restaurant, bar and pubs MIS reports</h2>
                <ul>
                  {misReportsLeft.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="restaurant-feature-list-section restaurant-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="restaurant-list-card">
                <div className="restaurant-section-label">Stock Reports</div>
                <h2>Kitchen raw material, stock and inventory reports</h2>
                <ul>
                  {stockReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="restaurant-list-card">
                <div className="restaurant-section-label">Purchase & Consumption</div>
                <h2>Purchase and consumption reports</h2>
                <ul>
                  {misReportsRight.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="restaurant-accounting-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="restaurant-accounting-title">
                <div className="restaurant-section-label">Accounting Reports</div>
                <h2 className="restaurant-section-title">
                  Full financial accounting and GST reports
                </h2>
                <p>
                  RestaurSof includes cash bank book, journal book, purchase,
                  sales, ledger, trial balance, expense trial, profit and loss,
                  bank reconciliation, cost centre, GST sales register and GSTR
                  reports for complete restaurant accounting.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="restaurant-accounting-grid">
                {accountingReports.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="restaurant-faq-section">
        <Container>
          <div className="restaurant-heading-center">
            <div className="restaurant-section-label">FAQ</div>
            <h2 className="restaurant-section-title">
              Questions about RestaurSof restaurant POS software
            </h2>
            <p>
              Important information for restaurants, bars and pubs looking for
              POS billing, KOT/BOT, inventory, kitchen raw material stock, GST
              and accounting software.
            </p>
          </div>

          <div className="restaurant-faq-list">
            {faqList.map((item) => (
              <div className="restaurant-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="restaurant-cta-section">
        <Container>
          <div className="restaurant-cta-card">
            <div>
              <span>Ready to modernize restaurant operations?</span>
              <h2>Use RestaurSof for POS, KOT, inventory and accounts.</h2>
              <p>
                Get a GST enabled restaurant, bar and pubs software with desktop
                and web application support, Android app, QR menu, kitchen raw
                material stock, inventory, MIS and full accounting.
              </p>
            </div>
            <Link to="/EmailContactForm" className="restaurant-btn restaurant-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="restaurant-solution-areas-section">
        <Container>
          <div className="restaurant-solution-areas-head">
            <div className="restaurant-section-label">Supported Solutions</div>
            <h2>Restaurant POS, inventory, kitchen stock and accounting solution areas</h2>
            <p>
              RestaurSof is designed around real restaurant operations. This
              section explains the supported business areas naturally for
              restaurant owners, bar managers, pub operators and food service
              businesses.
            </p>
          </div>

          <Row className="g-4">
            {solutionAreas.map((area) => (
              <Col lg={6} key={area.title}>
                <div className="restaurant-solution-area-card">
                  <h3>{area.title}</h3>
                  <p>{area.text}</p>

                  <div className="restaurant-solution-area-list">
                    {area.points.map((point) => (
                      <span key={point}>{point}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Restaurant;